import { split, cloneDeepWith, isObject, isString, isUndefined } from 'lodash'

export const cleanData = (obj: any) => {
  const result = cloneDeepWith(obj, function (v: any) {
    if (!isObject(v) && isUndefined(v)) {
      return null
    } else if (!isObject(v) && isString(v)) {
      return v.replace(/\t/g, '')
    }
  })

  return result
}

export const setDocFirestore = async (
  $fire: any,
  path: string,
  data: object,
  mergeOption: boolean
) => {
  const numSegments = split(path, '/').filter(
    (segment: string) => segment !== ''
  )
  const selectedMergeOption =
    mergeOption !== undefined && mergeOption !== null ? mergeOption : false

  const cleanedData = cleanData(data)

  if (numSegments.length % 2 === 0) {
    return await $fire.firestore
      .doc(path)
      .set({ ...cleanedData }, { merge: selectedMergeOption })
  } else {
    return await $fire.firestore.collection(path).add({ ...cleanedData })
  }
}
// Función que realiza correctamente una escritura
export const updateDocFirestore = async (
  $fire: any,
  path: string,
  data: object
) => {
  const cleanedData = cleanData(data)
  if (cleanedData?.originalUser) {
    delete cleanedData.originalUser
  }
  return await $fire.firestore.doc(path).update({ ...cleanedData })
}
